import React from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import * as styles from "./Features.module.scss";

import {
  featuresData,
  featuresHeading,
  featureCta,
  REGISTER_URL,
} from "@shared/arrays/sales";

export function Features() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.sectionHeading}>{featuresHeading}</h2>

        {featuresData.map((feature) => (
          <div
            key={feature.title}
            className={`${styles.row} ${feature.reversed ? styles.rowReversed : ""}`}
          >
            <div className={styles.content}>
              <h2 className={styles.title}>{feature.title}</h2>
              <ul className={styles.points}>
                {feature.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <ButtonBlack
                variant="outline"
                size="small"
                text={featureCta}
                href={REGISTER_URL}
                type="link"
              />
            </div>

            <div className={styles.media}>
              <img
                src={feature.image}
                alt={feature.imageAlt}
                width={660}
                height={500}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;
